// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__hnhJj","title":"Footer_title__vI1zX","contactLinks":"Footer_contactLinks__nZeZb","reserved":"Footer_reserved__p2rmu"};